import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF],
  strings: [
    'DV_WEB_FEEDBACK__send_us_feedback',
    'DV_WEB_FEEDBACK_feedback',
    'DV_WEB_FEEDBACK_select_related_device',
    'DV_WEB_FEEDBACK_select_option_dropdown_menu',
    'DV_WEB_FEEDBACK_dropdown_prompt',
    'DV_WEB_FEEDBACK_submit_button',
    'DV_WEB_FEEDBACK_no_device_website',
    'DV_WEB_SETTINGS_HEAD_YOUR_DEVICES',
  ] as const,
}
